import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg';
import Envelop from '../../assets/images/envelop.png';
import { useAuth } from '../../Context/AuthContext';

const ForgetPassword = () => {
  const form = useForm();
  const { sendConfirmationEmail } = useAuth();
  const { register, handleSubmit, formState: { errors } } = form;
  const navigate = useNavigate();

  const onSubmit = async (data) => {
      const { email } = data;
      console.log('Data to send to sendConfirmationEmail:', { email });

      localStorage.setItem('email', email);

      sendConfirmationEmail({email:email});
      navigate('/Otp'); 
   
  };

  return (
    <div className="Login-container">
      <div className="component-holder">
        <div className="filter">
          <div className="header-holder">
            <img className='logo' src={Logo} alt="logo" />
            <p>Intelligent Heritage Explorer</p>
          </div>
          <div className='login-form'>
            <form className="form-login-holder form-forgetpassword-holder" onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className='input-holder-email'>
                <label>Email address</label>
                <div className='input-with-icon' >
                  <input
                    type="email"
                    placeholder="Alex@email.com"
                    {...register('email', {
                      required: true,
                      pattern: /^[a-zA-Z0-9_.+-]+@(gmail\.com|yahoo\.com)$/
                    })}
                  />
                  <img
                    src={Envelop}
                    alt="Envelope"
                    className="icon"
                  />
                  {errors.email && errors.email.type === "required" && (
                    <p className="errorMsg">Email is required.</p>
                  )}
                  {errors.email && errors.email.type === "pattern" && (
                    <p className="errorMsg">Email is not valid.</p>
                  )}
                </div>
              </div>
              <div>
                <button className='login-button' type="submit">Send confirmation email</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
